import { OffersOffcanvas } from "./OffCanvas/Offers";

export default class QuickCart 
{
    constructor(options = {}) 
    {
        this.options = {
            productSelector: '.product__block',
            offersSelector: '.js-add_to_basket_section_offers',
            offerItemSelector: '.js-ab-add_to_basket-item',
            addToBasketSelector: '.js-ab-add_to_basket-item',
            preorderSelector: '[data-entity="preorder"]',
            quickCartSelector: '[data-entity="quick-cart"]',
            loadingTimeout: 2000,
            ...options,
        };

        this.offcanvas = null;

        this.init();
    }

    init() 
    {
        this.bindEvents();
    }

    bindEvents() 
    {
        document.addEventListener('click', this.handleQuickCartClick.bind(this));
    }

    handleQuickCartClick(e) 
    {
        const quickCartButton = e.target.closest(this.options.quickCartSelector);
        if (!quickCartButton) {
            return;
        }

        const product = quickCartButton.closest(this.options.productSelector);
        if (!product) {
            return;
        }

        const offersNode = product.querySelector(this.options.offersSelector);
        const addToBasketButton = product.querySelector(this.options.addToBasketSelector) || product.querySelector(this.options.preorderSelector);

        if (offersNode) {
            this.showOffcanvas(offersNode);
        } else if (addToBasketButton) {
            this.addToBasket(quickCartButton, addToBasketButton);
        }
    }

    showOffcanvas(offersNode) 
    {
        const offers = Array.from(
            offersNode.querySelectorAll(this.options.offerItemSelector)
        ).map(el => ({
            id: el.dataset.product,
            size: el.dataset.name,
            quantity: el.dataset.quantity,
        }));

        this.offers = new OffersOffcanvas();
        this.offers.show();
        this.offers.render(offers);
    }

    addToBasket(button, addToBasketButton) 
    {
        BX.Dom.addClass(button, 'btn__loading');

        addToBasketButton.click();

        setTimeout(() => {
            BX.Dom.removeClass(button, 'btn__loading');
        }, this.options.loadingTimeout);
    }


    destroy()
    {
        if (this.offers) {
            this.offers.hide();
            this.offers = null;
        }
        document.removeEventListener('click', this.handleQuickCartClick);
    }
}